import React, { useState, useEffect, useScroll } from "react"
import { Link } from "gatsby"
import styled, { ThemeProvider, css } from "styled-components"

const StyledH2 = styled.h2`
  font-family: "Cinzel", "serif";
  font-weight: normal;
  display: flex;
  font-size: 1rem;
  margin-bottom: 0;
  margin-top: 0;
  transition: font-size 0.5s;
  *, a{
  text-decoration: none;
  }
`

const FontLg = styled.span`
  font-size: 2em;
`

const FontTogglable = styled.span`
  max-width: ${props => props.maxW};
  font-size: 2em;
  flex-shrink: 1;
  flex-grow: 0;
  white-space: nowrap;
  overflow: hidden;
  transition: max-width 2s;
    height: 100%;
  ${StyledH2}:hover & {
    max-width: 100rem;
  }
`

const NameSpacer = styled.span`
    width: 0.4rem;
  transition: max-width 2s;
  max-width: ${props => props.maxW};

  ${StyledH2}:hover & {
    max-width: 100rem;
  }
`

const FontSm = styled.span`
  font-size: 0.75em;
  display: block;
  flex-grow: 0;
`

const FontSub = styled.span`
  font-size: 0.5em;
  display: block;
`

const VerticalWrap = styled.span`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  flex-shrink: 0;
  margin-top: ${props=>props.marginTop};
  justify-content: flex-end;
`

const Logo = ({marginTop}) => {
  const [maxW, setMaxW] = useState("1000rem")


  useEffect(() => {
    const timer = setTimeout(() => {
      setMaxW(0)
    }, 200)
    return () => clearTimeout(timer)
  }, [])
  
  return (
    <StyledH2 id="js-header">
      <FontLg>M</FontLg>
      <VerticalWrap>
        <FontTogglable maxW={maxW}>artin</FontTogglable>
      </VerticalWrap>
      <NameSpacer maxW={maxW}> </NameSpacer>
        <FontLg>J</FontLg>
      <VerticalWrap>
        <FontTogglable maxW={maxW}>ennings</FontTogglable>
      </VerticalWrap>
    </StyledH2>
  )
}

export default Logo
